import { type TAudio, type TSource, type TUploadPolicy, addSourceToAudioUrl } from '@core/api'
import { httpClient } from '@core/http-client'

import { type TCreateSourceForm } from '@core/models'
import { convertCreateSourceForm } from '@core/converters'

type TCreateAudioSourceRequestOptions = {
    signal?: AbortSignal
}

type TResponse = TUploadPolicy & {
    extra: {
        audio: TAudio
        source: TSource
    }
}

/**
 * Creates a new audio source.
 */
export const createAudioSource = (
    payload: TCreateSourceForm,
    options?: TCreateAudioSourceRequestOptions,
) => {
    const apiPayload = convertCreateSourceForm(payload)

    return httpClient
        .post(addSourceToAudioUrl(payload.id), {
            signal: options?.signal,
            json: apiPayload,
        })
        .json<TResponse>()
}
